import { BaseContainer } from 'primsell-shared-layer/components'
import * as S from './not-found.styles'
import { DocumentIcon } from 'primsell-shared-layer/assets/icons'

const NotFound = (): JSX.Element => {
  return (
    <BaseContainer>
      <S.Container>
        <DocumentIcon />
        <S.TitleTypography variant="h1">Campaign not active</S.TitleTypography>
        <S.DescriptionTypography color="grey">
          Your campaign is in “draft” state now. <br />
          Publish the campaign to see the info of this page.
        </S.DescriptionTypography>
      </S.Container>
    </BaseContainer>
  )
}

export { NotFound }
